export const QUOTATION_BOOKING_NOTES = [
  'Hotel, room and flight availability is subject to payment and final confirmation.',
  'Airline baggage and fare rules will apply as mentioned on the issued ticket.',
  'Entry tickets and optional activities are not included unless stated.',
  'Standard hotel check-in/check-out policies apply.',
  'Quotation is valid for 48 hours from issue.',
];
